import { type IIcon } from '@/app/types/iconType'

export const Trash2 = (props: Omit<IIcon, 'iconName'>) => {
    const { height = '14', width = '14', color = '#FC3969' } = props
    return (
        <svg width={width} height={height} viewBox='0 0 14 14' fill='none' xmlns='http://www.w3.org/2000/svg'>
            <path
                d='M5.5 5.5C5.91421 5.5 6.25 5.83579 6.25 6.25V10C6.25 10.4142 5.91421 10.75 5.5 10.75C5.08579 10.75 4.75 10.4142 4.75 10V6.25C4.75 5.83579 5.08579 5.5 5.5 5.5Z'
                fill={color}
            />
            <path
                d='M9.25 6.25C9.25 5.83579 8.91421 5.5 8.5 5.5C8.08579 5.5 7.75 5.83579 7.75 6.25V10C7.75 10.4142 8.08579 10.75 8.5 10.75C8.91421 10.75 9.25 10.4142 9.25 10V6.25Z'
                fill={color}
            />
            <path
                fillRule='evenodd'
                clipRule='evenodd'
                d='M3.78119 2.32349C3.80329 1.78224 4.028 1.26772 4.41256 0.883166C4.81797 0.477757 5.36782 0.25 5.94115 0.25H8.10292C8.67626 0.25 9.22611 0.477757 9.63152 0.883166C10.0161 1.26772 10.2408 1.78224 10.2629 2.32349H13.0441C13.4583 2.32349 13.7941 2.65927 13.7941 3.07349C13.7941 3.4877 13.4583 3.82349 13.0441 3.82349H12.3823V10.75C12.3823 12.4069 11.0392 13.75 9.38233 13.75H4.72626C3.08279 13.75 1.74373 12.4292 1.72709 10.7836C1.70525 8.62523 1.67427 5.43845 1.66468 3.82349H1C0.585786 3.82349 0.25 3.4877 0.25 3.07349C0.25 2.65927 0.585786 2.32349 1 2.32349H3.78119ZM5.47322 1.94383C5.59732 1.81972 5.76564 1.75 5.94115 1.75H8.10292C8.27843 1.75 8.44675 1.81972 8.57086 1.94383C8.67397 2.04694 8.73954 2.18057 8.75877 2.32349H5.2853C5.30454 2.18057 5.37011 2.04694 5.47322 1.94383ZM10.8823 3.82353V10.75C10.8823 11.5784 10.2108 12.25 9.38233 12.25H4.72626C3.90307 12.25 3.23531 11.5893 3.22701 10.7684C3.20515 8.60764 3.17429 5.43194 3.1647 3.82353H10.8823Z'
                fill={color}
            />
        </svg>
    )
}
